import React, { useState, useEffect } from 'react';
import './StudentInsights.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { Form } from 'react-bootstrap';
import Spinner from '../Spinner/Spinner';
import { Button } from 'react-bootstrap';
import { withRouter } from "react-router";
import { Tabs, Tab } from 'react-bootstrap';
import { withAuth } from "../../app/util/HOC";
import StudyCenterStats from './StudyCenterStats';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import { handleException } from "../../app/util/util";
import loaderColors1 from '../Spinner/loaderColors1.gif';
export function StudentInsights(props) {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const bookVOInfo = JSON.parse(localStorage.getItem('bookVO'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const [bookVO, setBookVO] = useState({});
    const [loading, setLoading] = useState(false);
    const [classVOList, setClassVOList] = useState(null);
    const [buttonClick, setButtonClick] = useState(false);
    const [errorInvalideClassCodeMsg, setErrorInvalideClassCodeMsg] = useState("");
    let getStudentClassDetails = () => getStudentClassDetails.bind();
    useEffect(() => {
        getStudentClassDetails();
        document.title = `${bookVOInfo && bookVOInfo.bookTitle !== undefined ? bookVOInfo.bookTitle : ""} | Insights | Aspen Publishing`;
    }, []);
    getStudentClassDetails = () => {
        let reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingTo": "ClassInsight",
                    "pageNavigatingFrom": "ClassInsight",
                },
                sessionVO: {
                    "appType": "web",
                    "deviceMacId": "",
                    "keepMeLoggedInFlag": keepMeLogIn,
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "deviceType": localStorage.getItem('deviceType'),
                    "browserName": localStorage.getItem('browserName'),
                    "sessionAuthenticationToken": userVO.sessionAuthenticationToken,
                },
            },
            "classVO": {
                "bookISBN": props.match.params.isbn
            }
        }
        const requestOptions1 = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(reqData)
        };
        setLoading(true);
        fetch(localStorage.getItem('ENV') + "/manageClassWebService/getClassDetailsRV", requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    if (data) {
                        if (data.classVOList) {
                            var classVOList = Array.isArray(data.classVOList) ? data.classVOList : [data.classVOList]
                            for (var i = 0; i < classVOList.length; i++) {
                                if (classVOList[i].fileList)
                                    classVOList[i].fileList = Array.isArray(classVOList[i].fileList) ? classVOList[i].fileList : [classVOList[i].fileList]
                            }
                            setClassVOList(classVOList)
                        }
                        setBookVO(data.bookVO);
                    }
                    setLoading(false);
                } else {
                    if (data.wkErrorCode) {
                        handleException(data);
                    }
                }
            }).catch(error => {
                setLoading(false);
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const enrollClass = (e) => {
        let clsCode = document.getElementById("txtBoxClassCode").value;
        if (clsCode !== undefined && clsCode !== null && clsCode.trim() !== "" && clsCode.length > 0) {
            let reqData = {
                "userVO": {
                    "userId": userVO.userId,
                    "userRole": userVO.userRole,
                    "userRoleId": userVO.userRoleId,
                    "userActivityVO": {
                        "pageNavigatingTo": "",
                        "lastViewedClassId": "",
                        "lastReadBookId": "250",
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingFrom": "class-insight",
                    },
                    sessionVO: {
                        "appType": "web",
                        "deviceMacId": "",
                        "keepMeLoggedInFlag": keepMeLogIn,
                        "deviceOS": localStorage.getItem('deviceOS'),
                        "deviceType": localStorage.getItem('deviceType'),
                        "browserName": localStorage.getItem('browserName'),
                        "sessionAuthenticationToken": userVO.sessionAuthenticationToken,
                    },
                },
                "classVO": {
                    "bookISBN": props.match.params.isbn,
                    "classCode": document.getElementById("txtBoxClassCode").value,
                }
            }
            const requestOptions1 = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(reqData)
            };
            fetch(localStorage.getItem('ENV') + "/manageClassWebService/enrollStudentInClass", requestOptions1)
                .then(response => response.json())
                .then(data => {
                    if (data && data.status === "true") {
                        data.classVO.fileList = data.classVO.fileList ? Array.isArray(data.classVO.fileList) ? data.classVO.fileList : [data.classVO.fileList] : null;
                        setClassVOList([data.classVO]);
                    } else {
                        if (data.httpErrorCode === "400" && data.wkErrorCode === "bus.exception.invalid.class.code") {
                            setErrorInvalideClassCodeMsg("Error: Invalid Class Code");
                        } else if (data.wkErrorCode) {
                            handleException(data);
                        }
                    }
                }).catch(error => {
                    console.error("There has been problem with fetch operation", error)
                });
        } else {
            setErrorInvalideClassCodeMsg("Error: Please provide a Class Code.");
        }
    }
    const dropClass = (e) => {
        let reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "ClassInsight",
                },
                "sessionVO": {
                    "appType": "web",
                    "deviceMacId": "",
                    "keepMeLoggedInFlag": keepMeLogIn,
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "deviceType": localStorage.getItem('deviceType'),
                    "browserName": localStorage.getItem('browserName'),
                    "sessionAuthenticationToken": userVO.sessionAuthenticationToken,
                }
            },
            "classVO": {
                "bookISBN": props.match.params.isbn,
                "classId": e.target.getAttribute("classId"),
            }
        }
        const requestOptions1 = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(reqData)
        };
        fetch(localStorage.getItem('ENV') + "/manageClassWebService/deleteStudentEnrollment", requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    setClassVOList(null)
                } else {
                    if (data.wkErrorCode) {
                        handleException(data);
                    }
                }
            }).catch(error => {
                console.error("There has been problem with fetch operation", error)
            });
    }
    const downloadAsset = (e) => {
        if (e.target.getAttribute("fileId")) {
            document.getElementById("userIdDownload").value = userVO.userId
            document.getElementById("userRoleDownload").value = userVO.userRole
            document.getElementById("userRoleIdDownload").value = userVO.userRoleId
            document.getElementById("appTypeDownload").value = "web"
            document.getElementById("deviceTypeDownload").value = localStorage.getItem('deviceType')
            document.getElementById("deviceOSDownload").value = localStorage.getItem('deviceOS')
            document.getElementById("fileIdDownload").value = e.target.getAttribute("fileId")
            document.getElementById("sessionAuthenticationTokenDownload").value = userVO.sessionAuthenticationToken;
            document.getElementById('downloadFormResource').action = localStorage.getItem('ENV') + "/manageClassWebService/downloadClassFile";
            document.getElementById('downloadFormResource').submit();
        }
    }
    const handleEnrollClassOnEnter = (e) => {
        if (e.key === 'Enter') {
            enrollClass();
        }
    }
    const handleDownloadAsset = (e) => {
        if (e.key === 'Enter') {
            downloadAsset(e);
        }
    }
    return (
        <React.Fragment>
            <Header userVO={userVO} bookVO={bookVO} pageName="insights" ></Header>
            <Spinner
                loading={loading}
                imageSrc={loaderColors1}
                overlayBackground="rgba(0,0,0,0.5)"
                label="Loading insights section" />
            <div className="col-lg-12 insightsContainer">
                <div className="row greyDiv">
                    <div className="col-lg-10 headingDiv">
                        <span className="insightProperty">{bookVO ? bookVO.bookTitle : null}</span><br />
                        <span className="insightHeading">Casebook Insights</span>
                    </div>
                    <div className="col-lg-2"></div>
                </div>
                <br />
                <div className="insightTabDiv col-lg-8 col-md-8 col-sm-8 col-xs-12">
                    <Tabs id="insight-tab" className="InsightTabs">
                        <Tab eventKey="classInformation" title="Class Information">
                            {
                                classVOList === null ?
                                    <div>
                                        <br />
                                        <span className="pText">Enroll in your professor's CasebookConnect class to stay connected.</span>
                                        <br /><br />
                                        <div className="mainDiv" style={{ padding: '1%' }}>
                                            {errorInvalideClassCodeMsg ? <div className="error-colorCode" style={{ padding: "0px" }}>{errorInvalideClassCodeMsg}</div> : null}
                                            <span className="iconText">Enter a class code</span>
                                            <br />
                                            <InputGroup className="mb-3">
                                                <FormControl data-testid="input_class_code" id="txtBoxClassCode" className="classCodeInput"
                                                    aria-label="Class Code" aria-describedby="basic-addon2"
                                                    style={{ height: '30px' }} onKeyPress={handleEnrollClassOnEnter}
                                                />
                                                <InputGroup.Append style={{ height: '30px' }}>
                                                    <Button variant="outline-secondary" className="enrollButton" onClick={enrollClass}>Enroll</Button>
                                                </InputGroup.Append>
                                            </InputGroup>
                                        </div>
                                    </div> :
                                    classVOList.map((classObj, index) => (
                                        <div>
                                            <br />
                                            <span className="pText">Stay connected with your professor and class </span>
                                            <br /> <br />
                                            <div className="mainDiv">
                                                <div className="propertyFallDiv">
                                                    <span className="fallText">{classObj.className}</span>
                                                    <button className="propertyButton" classId={classObj.classId} style={{ float: 'right' }} onClick={dropClass}>Drop Class</button>
                                                </div>
                                                <div style={{ padding: '1%' }}>
                                                    {
                                                        classObj.professorVO ?
                                                            <span className="iconText">Professor {classObj.professorVO.firstName} {classObj.professorVO.lastName}</span> :
                                                            <span className="iconText">Professor {classObj.profFirstName} {classObj.profLastName}</span>
                                                    }
                                                    <br />
                                                    <span className="iconText">{classObj.classDescription}</span>
                                                    <br /> <br />
                                                    {
                                                        classObj.fileList ?
                                                            <span className="insightHeading">Class Documents</span> : null
                                                    }
                                                    <br />
                                                    <div id="fileDocs1" className="row">
                                                        {
                                                            classObj.fileList ? classObj.fileList.map((file, index) => (
                                                                <div data-testid={`file_${classObj.classId}`} className="col-lg-3" classId={classObj.classId} fileId={file.fileId}
                                                                    fileName={file.fileName} fileType={file.fileType} onClick={downloadAsset} >
                                                                    <div className="fileDiv" fileId={file.fileId} >
                                                                        <i className='fas fa-file-alt fileIcon' fileId={file.fileId} ></i>
                                                                    </div>
                                                                    <span data-testid={`file_download_${classObj.classId}`} className="fileName" fileId={file.fileId} tabIndex="0" onKeyDown={(e) => handleDownloadAsset(e)}>{file.fileName}</span>
                                                                </div>
                                                            )) : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                            }
                            <Form method="POST" id="downloadFormResource">
                                <input type="hidden" id="userIdDownload" name="userId" />
                                <input type="hidden" id="userRoleDownload" name="userRole" />
                                <input type="hidden" id="userRoleIdDownload" name="userRoleId" />
                                <input type="hidden" id="appTypeDownload" name="appType" />
                                <input type="hidden" id="deviceTypeDownload" name="deviceType" />
                                <input type="hidden" id="deviceOSDownload" name="deviceOS" />
                                <input type="hidden" id="sessionAuthenticationTokenDownload" name="sessionAuthenticationToken" />
                                <input type="hidden" id="fileIdDownload" name="fileId" />
                            </Form>
                        </Tab>
                        <Tab eventKey="studyCenter" title="Study Center">
                            <StudyCenterStats classVOList={classVOList}></StudyCenterStats>
                        </Tab>
                    </Tabs>
                </div>
            </div>
            <Footer />
        </React.Fragment>
    );
}
export default withAuth(withRouter(StudentInsights));